import { render, staticRenderFns } from "./block_wrapper.vue?vue&type=template&id=a474baf0&"
import script from "./block_wrapper.vue?vue&type=script&lang=js&"
export * from "./block_wrapper.vue?vue&type=script&lang=js&"
import style0 from "./block_wrapper.vue?vue&type=style&index=0&id=a474baf0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports